// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2FRjv","vLegacy":"SelectSecondary_vLegacy__J9vix","error":"SelectSecondary_error__24yN5","disabled":"SelectSecondary_disabled__1fHMp"};